// extracted by mini-css-extract-plugin
module.exports = {"container":"MoreCollectionSection_container__B5ep5","title":"MoreCollectionSection_title__APJDP","lightTitle":"MoreCollectionSection_lightTitle__0LgLA"};